// @flow
import React from 'react'
import { ClearFix } from '../controls'
import styled, { type StyledComponent } from 'styled-components'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import type { Media, Crop } from '../../types'

import visitIcon from '../images/google-visit-btn.png'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 300px;
  border: 1px solid #cecece;
  background: #fff;
  float: left;
  word-wrap: break-word;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  padding: 5px 15px 6px;
  background-color: #535353;
  color: #ffffff;
  font-size: 24px;
  line-height: 100%;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  line-height: 110%;
  color: #272727;
  padding-bottom: 5px;
  max-width: 225px;
`
const Url: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  line-height: 100%;
  color: #4f4f4f;
`
const Info: StyledComponent<Object, any, any> = styled.div`
  padding: 10px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 10px;
    right: 11px;
    width: 42px;
    height: 42px;
    background: url(${visitIcon}) no-repeat;
  }
`

type Props = {|
  url: string,
  title: string,
  description: string,
  image: ?Media,
  imageCrop: ?Crop
|}

export default function GooglePreview(props: Props) {
  const { url, title, description, image, imageCrop } = props

  return (
    <Wrapper>
      <ClearFix>
        <OptionalResponsibleImage
          image={image}
          imageCrop={imageCrop}
          width={298}
          ratio={1.91}
          float
        />
      </ClearFix>
      <Title>{title}</Title>
      <Info>
        <Text>{description}</Text>
        <Url>{url}</Url>
      </Info>
    </Wrapper>
  )
}
